import i18next from "i18next";
import { success, custom } from "./utilities";
import { ToastifyService, competitionService } from "../../services";
import {
  translationConstants,
  refreshDispatch,
  globalSystemConstants,
  competitionConstants,
  loginConstants,
  roles,
} from "../../constants";
import { downloadBase64File, getUserPayload } from "../../system";
import { authActions } from "./auth.action";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
};

const toggleViewMode = (mode) => {
  return (dispatch) =>
    dispatch(success(mode, competitionConstants.VIEW_ADD_COMPETITION));
};

const toggleViewModal = (mode) => {
  return (dispatch) =>
    dispatch(success(mode, competitionConstants.COMPETITION_MODAL));
};

export const getPublicCompetitions = (gridData) => {
  return (dispatch) => {
    competitionService
      .getPublicCompetitions(gridData)
      .then((response) =>
        dispatch(
          success(response, competitionConstants.COMPETITION_PUBLIC_DATA)
        )
      )
      .catch((error) => ToastifyService.showError(error));
  };
};

export const getPublicCompetitionById = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getPublicCompetitionById(id)
      .then((response) => {
        dispatch(
          success(response, competitionConstants.COMPETITION_PUBLIC_DATA_ID)
        );
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getCompetitions = (gridData) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitions(gridData)
      .then((response) =>
        dispatch(success(response, competitionConstants.COMPETITION_DATA))
      )
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getCompetitionById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitionById(id)
      .then((response) => {
        dispatch(success(response, competitionConstants.COMPETITION_DATA_ID));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const addCompetition = (competitionData, navigate) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .addCompetition(competitionData)
      .then((response) => {
        if (response) {
          dispatch(
            getCompetitions({ ...gridData, filterQuery: "status != 3" })
          );
          ToastifyService.showSuccess(response);
          if (navigate) {
            navigate();
          }
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateCompetition = (competitionData, navigate) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.UPDATE_CENTER_ACTIVITY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .updateCompetition(competitionData)
      .then((response) => {
        if (response) {
          dispatch(
            getCompetitions({ ...gridData, filterQuery: "status != 3" })
          );
          ToastifyService.showSuccess(response);
          if (navigate) {
            navigate();
          }
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.UPDATE_CENTER_ACTIVITY,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateCompetitionStatusById = (id, status, navigate) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.UPDATE_CENTER_ACTIVITY_BY_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .updateCompetitionStatusById(id, status)
      .then((response) => {
        if (response) {
          dispatch(
            getCompetitions({ ...gridData, filterQuery: "status != 3" })
          );
          ToastifyService.showSuccess(response);
          if (navigate) {
            navigate();
          }
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.UPDATE_CENTER_ACTIVITY_BY_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const deleteCompetitionById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.DELETE_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .deleteCompetitionById(id)
      .then((response) => {
        if (response) {
          dispatch(
            getCompetitions({ ...gridData, filterQuery: "status != 3" })
          );
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.DELETE_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const getMyCompetitions = (gridData, userId) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getMyCompetitions(gridData, userId)
      .then((response) =>
        dispatch(success(response, competitionConstants.MY_COMPETITION_DATA))
      )
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const validateParticipentsForCompetition = (
  systemUserId,
  competitionId,
  setSelectedCompetition,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.VALIDATE_PARTICIPANTS_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .validateParticipentsForCompetition(systemUserId, competitionId)
      .then((response) => {
        dispatch(
          authActions.setIsMemberStatusInLoginReducer(
            response.payload.isMembershipHolder
          )
        );
        dispatch(
          success(
            response,
            competitionConstants.VALIDATE_PARTICIPANTS_COMPETITION
          )
        );
        if (onSuccess) {
          onSuccess();
        }
        ToastifyService.showSuccess(response.message);
      })
      .catch((error) => {
        const userData = getUserPayload();
        if (
          userData?.user?.role === roles.Center ||
          userData?.user?.role === roles.Admin ||
          userData?.user?.role === roles.SuperAdmin
        ) {
          ToastifyService.showError(translationConstants.INVALID_USER);
        } else {
          ToastifyService.showError(error);
        }
        setSelectedCompetition(null);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.VALIDATE_PARTICIPANTS_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const validateParticipentsForCompetitionFalse = () => {
  return (dispatch) => {
    dispatch(custom(null, competitionConstants.VALIDATE_PARTICIPANTS_FALSE));
  };
};

export const getCompetitionGeneralDetailById = (id, screenName) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitionGeneralDetailById(id)
      .then((response) => {
        response.screen = screenName;
        dispatch(
          success(response, competitionConstants.GET_COMPETITION_GENERAL_DATA)
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getCompetitionParticipantsDetailById = (id, gridData) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitionParticipantsById(id, gridData)
      .then((response) => {
        dispatch(
          success(
            response,
            competitionConstants.GET_COMPETITION_PARTICIPANTS_DATA
          )
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const cancelRegistrationPublic = (
  systemUserId,
  competitionId,
  setIsNavigate,
  refresh
) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.CANCEL_PUBLIC_REGISRATION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .cancelRegistrationPublic(systemUserId, competitionId)
      .then((response) => {
        if (response) {
          ToastifyService.showSuccess(response);
          if (refresh === refreshDispatch.MY_COMPETITION) {
            dispatch(
              getMyCompetitions(
                {
                  length: 7,
                  search: null,
                  pageNumber: 1,
                  orderBy: "id desc",
                  filterQuery: null,
                },
                getUserPayload().user?.id
              )
            );
            dispatch(getCompetitionStats(getUserPayload().user?.id));
          }
          if (setIsNavigate) setIsNavigate(true);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.CANCEL_PUBLIC_REGISRATION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const publishScore = (id, callback) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .publishScore(id)
      .then((response) => {
        dispatch(getCompetitionGeneralDetailById(id));
        ToastifyService.showSuccess(response);
        dispatch(callback);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const cancelRegistrationPrivate = (
  systemUserId,
  competitionId,
  setIsNavigate,
  refresh
) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.CANCEL_PRIVATE_REGISRATION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .cancelRegistrationPrivate(systemUserId, competitionId)
      .then((response) => {
        if (response) {
          if (refresh === refreshDispatch.MY_COMPETITION) {
            dispatch(
              getMyCompetitions(
                {
                  length: 7,
                  search: null,
                  pageNumber: 1,
                  orderBy: "id desc",
                  filterQuery: null,
                },
                getUserPayload().user?.id
              )
            );
            dispatch(getCompetitionStats(getUserPayload().user?.id));
          }
          if (refresh === refreshDispatch.PARTICIPANT_ADMIN) {
            dispatch(
              getCompetitionParticipantsDetailById(competitionId, gridData)
            );
          }
          ToastifyService.showSuccess(response);
          if (setIsNavigate) setIsNavigate(true);
          dispatch(participantByEmailNull());
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.CANCEL_PRIVATE_REGISRATION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getParticipantByEmail = (email) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getParticipantByEmail(email)
      .then((response) => {
        dispatch(
          success(
            response,
            competitionConstants.GET_COMPETITION_PARTICIPANTS_BY_EMAIL
          )
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
        dispatch(participantByEmailNull());
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const participantByEmailNull = () => {
  return (dispatch) => {
    dispatch(
      custom(null, competitionConstants.COMPETITION_PARTICIPANTS_BY_EMAIL_NULL)
    );
  };
};

export const addParticipant = (data, setShow, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .addParticipant(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        if (setShow) setShow(false);
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const addParticipantWithPayment = (
  checkoutId,
  boatClassId,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .addParticipantWithPayment(checkoutId, boatClassId)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const download = (competitionId, gridData) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .download(competitionId, gridData)
      .then((response) => {
        downloadBase64File(response.content, null, response.fileName);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateScore = (
  competitionId,
  data,
  defaultGridState,
  setIsSaveShow
) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .updateScore(competitionId, data)
      .then((response) => {
        dispatch(
          getCompetitionParticipantsDetailById(competitionId, defaultGridState)
        );
        dispatch(getCompetitionGeneralDetailById(competitionId));
        ToastifyService.showSuccess(response);
        setIsSaveShow(true);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const uploadFiles = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .uploadFiles(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getUploadedFile = (competitionId, setIsUploadResult) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.ADD_COMPETITION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getUploadedFile(competitionId)
      .then((response) => {
        dispatch(success(response, competitionConstants.GET_UPLOADED_FILE));
        setIsUploadResult(true);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.ADD_COMPETITION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const getCompetitionStats = (id) => {
  return (dispatch) => {
    competitionService
      .getCompetitionStats(id)
      .then((response) => {
        dispatch(success(response, competitionConstants.GET_COMPETITION_STATS));
      })
      .catch((error) => {
        ToastifyService.showError(i18next.t(error));
      });
  };
};
export const getCompetitionQuestion = (token) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.GET_COMPETITION_FEEDBACK_QUESTION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitionQuestion(token)
      .then((response) => {
        dispatch(
          success(
            response,
            competitionConstants.GET_COMPETITION_FEEDBACK_QUESTION
          )
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.GET_COMPETITION_FEEDBACK_QUESTION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const getCompetitionDetailResult = (id) => {
  return (dispatch) => {
    competitionService
      .getCompetitionDetailResult(id)
      .then((response) => {
        //downloadBase64File()
        dispatch(
          success(response, competitionConstants.GET_COMPETITION_DETAIL_RESULT)
        );
      })
      .catch((error) => {
        ToastifyService.showError(i18next.t(error));
      });
  };
};

export const refundPublicCompetition = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.CANCEL_PUBLIC_REGISRATION,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .refundPublicCompetition(data)
      .then((response) => {
        if (response) {
          dispatch(
            getCompetitionParticipantsDetailById(data.competitionId, gridData)
          );
          ToastifyService.showSuccess(response);
          if (onSuccess) {
            onSuccess();
          }
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.CANCEL_PUBLIC_REGISRATION,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const saveCompetitionFeedback = (data, token, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.SAVE_COMPETITION_FEEDBACK,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .saveCompetitionFeedback(data, token)
      .then((response) => {
        if (response) {
          setShow(false);
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.SAVE_COMPETITION_FEEDBACK,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getCompetitionFeedbackById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.GET_COMPETITION_FEEDBACK,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitionFeedbackById(id)
      .then((response) => {
        if (response) {
          dispatch(
            success(response, competitionConstants.GET_COMPETITION_FEEDBACK)
          );
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.GET_COMPETITION_FEEDBACK,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const competitionRegistrationwithSavedCard = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    competitionService
      .competitionRegistrationwithSavedCard(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const getCompetitionTotalPaymentById = (competitionId) => {
  return (dispatch) => {
    competitionService
      .getCompetitionTotalPaymentById(competitionId)
      .then((response) =>
        dispatch(
          success(
            response,
            competitionConstants.COMPETITION_TOTAL_PAYMENT_BY_ID_DATA
          )
        )
      )
      .catch((error) => ToastifyService.showError(error));
  };
};

export const getCompetitionLeaderboardBoatClasses = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        competitionConstants.COMP_LEADERBOARD_BOAT_CLASSES,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    competitionService
      .getCompetitionLeaderboardBoatClasses(id)
      .then((response) =>
        dispatch(
          success(response, competitionConstants.COMP_LEADERBOARD_BOAT_CLASSES)
        )
      )
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            competitionConstants.COMP_LEADERBOARD_BOAT_CLASSES,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const competitionActions = {
  toggleViewMode,
  toggleViewModal,
  getPublicCompetitions,
  getPublicCompetitionById,
  getCompetitions,
  getCompetitionById,
  addCompetition,
  updateCompetition,
  updateCompetitionStatusById,
  deleteCompetitionById,
  getMyCompetitions,
  validateParticipentsForCompetition,
  validateParticipentsForCompetitionFalse,
  cancelRegistrationPublic,
  cancelRegistrationPrivate,
  getCompetitionGeneralDetailById,
  getCompetitionParticipantsDetailById,
  publishScore,
  getParticipantByEmail,
  participantByEmailNull,
  addParticipant,
  addParticipantWithPayment,
  download,
  updateScore,
  uploadFiles,
  getUploadedFile,
  getCompetitionStats,
  getCompetitionQuestion,
  getCompetitionDetailResult,
  refundPublicCompetition,
  saveCompetitionFeedback,
  getCompetitionFeedbackById,
  competitionRegistrationwithSavedCard,
  getCompetitionTotalPaymentById,
  getCompetitionLeaderboardBoatClasses,
};
